export const dashboard = {
    en: {
        privacySetupSubtitleDefined: 'Preferences',
        device: 'Device',
        welcomeMessage: "Welcome {name},",
        privacySetupSubtitle: "Configure your privacy setup",
        edit: "Edit",
        save: "Save",
        close: "Cancel",
        getStarted: "Start your journey >>",
        selectProfile: "Select your protection profile",
        selectOsType: "Select your device",
        androidTitle: "Android (Samsung)",
        androidDescription: "From Galaxy A05 to S24.",
        iosTitle: "iPhone/iPad",
        iosDescription: "From iPhone X onwards.",
        pixelTitle: "Google Pixel",
        pixelDescription: "Pixel 6 onwards, stock Android.",
        grapheneTitle: "Graphene OS",
        grapheneDescription: "Google Pixel devices running GrapheneOS.",
        continue: "Continue",
        view: "View",
        inProgress: "In Progress",
        completed: "Completed",
        current: "Current: {progress}",
        submodules: "Submodules:",
        yourProgress: "Your progress",
        go: "Go",
        purchaseRequired: "Purchase a license to unlock all profiles",
        contentsTitle: "Contents",
        selectProfilePrompt: "Select one of the available profiles to browse their contents",
        licenseExpiredAlert: "Your license is expired, click here to extend your journey!",
        inviteTooltip: 'Invite friends and family and earn a month off!',
        inviteUsers: 'Invite users',
        inviteEmailSubject: 'Join me on SecurePath',
        inviteEmailBody: 'Check out SecurePath at {storeURL} and use my code {code} to sign up!',
    },
    pt: {
        privacySetupSubtitleDefined: 'Preferências',
        device: 'Dispositivo',
        welcomeMessage: "Bem-vindo(a) {name},",
        privacySetupSubtitle: "Configure sua privacidade",
        edit: "Editar",
        save: "Salvar",
        close: "Cancelar",
        getStarted: "Comece sua jornada >>",
        selectProfile: "Selecione seu perfil de proteção",
        selectOsType: "Selecione seu dispositivo",
        androidTitle: "Android (Samsung)",
        androidDescription: "De Galaxy A05 até S24.",
        iosTitle: "iPhone/iPad",
        iosDescription: "A partir do iPhone X.",
        pixelTitle: "Google Pixel",
        pixelDescription: "Do Pixel 6 em diante, Android puro.",
        grapheneTitle: "Graphene OS",
        grapheneDescription: "Aparelhos Google Pixel com GrapheneOS.",
        continue: "Continuar",
        view: "Visualizar",
        inProgress: "Em Progresso",
        completed: "Completo",
        current: "Atual: {progress}",
        submodules: "Submódulos:",
        yourProgress: "Seu progresso",
        go: "Ir",
        purchaseRequired: "Compre uma licença para liberar todos perfis",
        contentsTitle: "Conteúdo",
        licenseExpiredAlert: "Sua licença expirou, clique aqui para estender sua jornada!",
        inviteTooltip: 'Convide amigos e família e ganhe um mês grátis!',
        inviteUsers: 'Convidar usuários',
        inviteEmailSubject: 'Junte-se a mim no SecurePath',
        inviteEmailBody: 'Confira o SecurePath em {storeURL} e use meu código {code} para se registrar!',
        selectProfilePrompt: "Selecione um dos perfis disponíveis para visualizar seus conteúdos"
    },
    es: {
        privacySetupSubtitleDefined: 'Preferencias',
        device: 'Dispositivo',
        welcomeMessage: "Bienvenido(a) {name},",
        privacySetupSubtitle: "Configura tu privacidad",
        edit: "Editar",
        save: "Guardar",
        close: "Cancelar",
        getStarted: "Comenzar tu viaje >>",
        selectProfile: "Selecciona tu perfil de protección",
        selectOsType: "Selecciona tu dispositivo",
        androidTitle: "Android (Samsung)",
        androidDescription: "Desde Galaxy A05 hasta S24.",
        iosTitle: "iPhone/iPad",
        iosDescription: "Desde el iPhone X en adelante.",
        pixelTitle: "Google Pixel",
        pixelDescription: "Desde el Pixel 6 en adelante, Android puro.",
        grapheneTitle: "Graphene OS",
        grapheneDescription: "Teléfonos Google Pixel con GrapheneOS.",
        continue: "Continuar",
        view: "Ver",
        inProgress: "En Progreso",
        completed: "Completado",
        current: "Actual: {progress}",
        submodules: "Submódulos:",
        yourProgress: "Su progreso",
        go: "Ir",
        purchaseRequired: "Compra una licencia para desbloquear todos los perfiles",
        contentsTitle: "Contenido",
        licenseExpiredAlert: "¡Su licencia ha expirado, haga clic aquí para extender su recorrido!",
        inviteTooltip: '¡Invita a familiares y amigos y gana un mes gratis!',
        inviteUsers: 'Invitar usuarios',
        inviteEmailSubject: 'Únete a mí en SecurePath',
        inviteEmailBody: 'Visita SecurePath en {storeURL} y usa mi código {code} para registrarte!',
        selectProfilePrompt: "Seleccione uno de los perfiles disponibles para explorar sus contenidos"
    },
};
